import { 
    SET_FINANCE_ACCOUNTS_LIST,
    DISPLAY_ACCOUNT_NAME_MODAL
  } from './constants';

  export const displayFinanceAccountsList = (data) => ({
    type: SET_FINANCE_ACCOUNTS_LIST, 
    payload: data
  });

  export const displayEditAccountModalVisibility = visible => ({
    type: DISPLAY_ACCOUNT_NAME_MODAL,
    payload: visible
  });



// WEBPACK FOOTER //
// ./src/features/finance/accounts/actionTypes.js